import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';
import { MESSAGING_API_BASE, messagingQueryKeys } from '../config';
import { ChannelResponse, ChannelStatusEnum } from '../types/backend';
import { updateChannelInCache } from '../utils/updateChannelCache';

export type ArchiveChannelDTO = {
  channelId: number;
  version: number;
};

const archiveChannel = async (
  data: ArchiveChannelDTO
): Promise<ChannelResponse> => {
  const { channelId, version } = data;

  return axios.post(`${MESSAGING_API_BASE}/channels/${channelId}/archive`, {
    version,
  });
};

export const useArchiveChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ArchiveChannelDTO) => archiveChannel(data),
    onSuccess: (_, variables) => {
      // Update channel status in cache immediately (optimistic update for current user)
      updateChannelInCache(queryClient, variables.channelId, {
        status: ChannelStatusEnum.ARCHIVED,
      });
    },
  });
};
